module.exports = __webpack_public_path__ + "img/product_mb_new_04.0966f85.webp";